import React, { FC } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import ClientDownload from '../../../components/common/ClientDownload'

const Index: FC = () => {
  const { t } = useTranslation()

  return (
    <section className="setting_page">
      <Helmet>
        <title>{`Qasee - 設定 - 個人設定 - ${t("client.download.title")}`}</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        個人設定
        &nbsp;&gt;&nbsp;
        {t("client.download.title")}
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          {t("client.download.title")}
        </h1>
      </section>
      <section className="page_contents content-area">
        <ClientDownload />
      </section>
    </section>
  )
}

export default Index
